import React from "react";
import fb from "../MODELS/FirebaseModule";
import Container from "react-bootstrap/Container";
import "firebase/auth";

const auth = fb.auth();

function SignIn() {
  const signInWithGoogle = () => {
    const provider = new fb.auth.GoogleAuthProvider();
    auth.signInWithPopup(provider);
  };

  return (
    <>
      <Container>
        <div className="row">
          <div className="col-md-4"></div>
          <div className="col-md-4">
            <button className="sign-in" onClick={signInWithGoogle}>
              Sign in with Google
            </button>
          </div>
          <div className="col-md-4"></div>
        </div>
      </Container>
    </>
  );
}
export default SignIn;
